/* ============================================================
   OBF LP BUNDLE — engine (LANDING-PAGE ONLY)

   A self-contained copy of the PDP bundle engine, used ONLY by
   sections/obf-lp-buybox.liquid via snippets/obf-lp-bundle.liquid.
   The live product page keeps its own assets/obf-bundle.js — this
   file is NEVER loaded there, so PDP behaviour is untouched.

   Differences vs the PDP engine:
   1. A 1-PAIR card renders too (qty >= 1), so the LP has no separate
      native single-pair form. Every purchase (1/2/3 pairs) goes through
      this widget's own CTA + /cart/add.js.
   2. There is no native <variant-selects> to sync — instead, when the top
      colour/gender changes, we dispatch `obf-lp:color` on document; the LP
      buy box listens and swaps the gallery slide (or shows an overlay image
      for the OTHER gender's product). (No pushTheme / native picker.)
   3. The 1-pair card has no free gift (gifts start at 2 pairs, unchanged).

   v7 (2026-07-05) — PDP-parity top pickers:
   The engine now renders TOP-LEVEL gender / colour / size pickers (renderTop),
   mirroring snippets/product-option.liquid markup + classes (.obf-gender,
   .product-form__input--color/.obf-swatch-scroll, .product-form__input--block,
   .obf-sizehelp) wrapped in `.variations` so the theme CSS styles them exactly
   like the PDP. S.top {gender,color,size} is the single source of truth; the
   tier cards SEED pair 0 from S.top (top pickers ARE pair 1). The Women/Men
   switch toggles in-place (no navigation) — it swaps colours/sizes/price/gallery
   to the other product using config.products.{Women,Men}. In-card pickers now
   render only for the EXTRA pairs (index >= 1) of 2/3-pair packs.
   ============================================================ */

(function () {
  'use strict';

  function money(cents, fmt) {
    var s = (cents / 100).toFixed(2);
    return fmt && fmt.indexOf('{{amount}}') !== -1 ? fmt.replace('{{amount}}', s) : '$' + s;
  }

  function optIdx(product, name) {
    if (!product || !product.options) return -1;
    var lc = (name || '').toLowerCase();
    for (var i = 0; i < product.options.length; i++)
      if ((product.options[i].name || '').toLowerCase() === lc) return i;
    return -1;
  }
  function optVals(product, name) {
    var i = optIdx(product, name);
    return i === -1 ? [] : (product.options[i].values || []);
  }
  function findVariant(product, color, size) {
    if (!product) return null;
    var ci = optIdx(product, 'Color'), si = optIdx(product, 'Size');
    for (var i = 0; i < product.variants.length; i++) {
      var v  = product.variants[i];
      var mc = ci === -1 || v['option'+(ci+1)] === color;
      var ms = si === -1 || v['option'+(si+1)] === size;
      if (mc && ms) return v;
    }
    return null;
  }
  function prodForGender(products, gender) { return products[gender] || null; }

  function thumbFor(products, gender, color, size) {
    var p = gender ? prodForGender(products, gender) : (products.Women || products.Men);
    if (!p) return '';
    if (color) {
      var v = findVariant(p, color, size);
      if (v && v.image) return v.image;
      var ci = optIdx(p, 'Color');
      if (ci !== -1) {
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i]['option'+(ci+1)] === color && p.variants[i].image)
            return p.variants[i].image;
        }
      }
    }
    return p.image || '';
  }

  /* Variant featured-media id for a colour (drives the LP gallery swap). */
  function colorMediaId(products, gender, color) {
    var p = gender ? prodForGender(products, gender) : (products.Women || products.Men);
    if (!p || !color) return '';
    var ci = optIdx(p, 'Color');
    if (ci === -1) return '';
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i]['option'+(ci+1)] === color && p.variants[i].mediaId)
        return String(p.variants[i].mediaId);
    }
    return '';
  }

  function openDrawer() {
    var sels = ['cart-drawer','#cart-drawer','#CartDrawer','[data-cart-drawer]','.cart-drawer','.drawer--cart','.js-cart-drawer'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) {
        if (typeof el.open === 'function') { el.open(); return; }
        el.classList.add('active','open','is-open','is-active','cart-drawer--open');
        el.removeAttribute('hidden'); el.setAttribute('aria-hidden','false');
        return;
      }
    }
    ['cart:open','cart:toggle','drawer:open','openCartDrawer','cart-drawer:open'].forEach(function(n){
      document.dispatchEvent(new CustomEvent(n,{bubbles:true}));
      window.dispatchEvent(new CustomEvent(n,{bubbles:true}));
    });
    var btn = document.querySelector('[data-cart-toggle],[data-drawer-toggle="cart"],.cart-drawer__toggle,#CartToggle,[aria-controls="cart-drawer"]');
    if (btn) { btn.click(); return; }
    window.location.href = '/cart';
  }

  function e(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function sizeLabel(s) {
    var out = String(s || '');
    out = out.replace(/^\s*[wmWM]\s*(?=[\d.])/, '');
    out = out.replace(/([\d.])\s*[wmWM]\s*$/, '$1');
    out = out.trim();
    return out || String(s || '');
  }

  function colorDropdownHtml(kindAttrs, value, colors, thumbFn) {
    var caret = '<svg class="obf-color-dd-arrow" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="#1B3644" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var h = '<div class="obf-color-dd" ' + kindAttrs + '>';
    var curThumb = value ? thumbFn(value) : '';
    var btnThumb = curThumb
      ? '<img class="obf-color-dd-thumb" src="'+e(curThumb)+'" alt="" width="18" height="18" loading="lazy" decoding="async">'
      : '<span class="obf-color-dd-thumb obf-color-dd-thumb--empty" aria-hidden="true"></span>';
    h += '<button type="button" class="obf-color-dd-btn" aria-haspopup="listbox" aria-expanded="false">';
    h += btnThumb + '<span class="obf-color-dd-label">'+e(value || '—')+'</span>' + caret + '</button>';
    h += '<div class="obf-color-dd-menu" role="listbox" hidden>';
    colors.forEach(function(c) {
      var ct  = thumbFn(c);
      var img = ct ? '<img src="'+e(ct)+'" alt="" width="34" height="34" loading="lazy" decoding="async">' : '';
      h += '<button type="button" class="obf-color-dd-opt'+(value===c?' is-sel':'')+'" role="option" data-value="'+e(c)+'" aria-selected="'+(value===c?'true':'false')+'">'+img+'<span>'+e(c)+'</span></button>';
    });
    h += '</div></div>';
    return h;
  }

  function productColorThumb(prod, color) {
    if (!prod) return '';
    var ci = optIdx(prod, 'Color');
    if (ci !== -1 && color) {
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i]['option'+(ci+1)] === color && prod.variants[i].image) return prod.variants[i].image;
      }
    }
    return prod.image || '';
  }

  function handleize(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }

  /* Featured-media id for a colour on a specific product (top swatch → gallery). */
  function colorMediaIdForProduct(prod, color) {
    if (!prod || !color) return '';
    var ci = optIdx(prod, 'Color');
    if (ci === -1) return '';
    for (var i = 0; i < prod.variants.length; i++) {
      if (prod.variants[i]['option'+(ci+1)] === color && prod.variants[i].mediaId)
        return String(prod.variants[i].mediaId);
    }
    return '';
  }

  /* Swatch fill image for a colour (larger, for the 58px swatch). */
  function colorSwatchImg(prod, color) {
    if (!prod || !color) return '';
    var ci = optIdx(prod, 'Color');
    if (ci !== -1) {
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i]['option'+(ci+1)] === color && prod.variants[i].image) return prod.variants[i].image;
      }
    }
    return '';
  }

  /* ════════════════════════════════════════════════════════════ */
  function OBFLpBundle(root) {
    var config;
    try { config = JSON.parse(root.getAttribute('data-obf-config')); }
    catch(err){ console.error('[OBF-LP]',err); return; }

    var GP = config.giftProducts || {};

    if (!root.querySelector('[data-obf-tiers]') || !root.querySelector('[data-obf-cta]')) {
      console.warn('[OBF-LP] bundle hooks missing inside [data-obf-lp-bundle]; skipping init');
      return;
    }

    /* S.top = the top-level single-source-of-truth selection (gender/color/size),
       exactly like the PDP's native variant picker. The tier cards seed their
       pairs from S.top; the size buttons / colour swatches / gender switch all
       write into S.top and re-render everything. */
    var S = { tierId: null, pairs: [], giftSel: {}, top: { gender: '', color: '', size: '' } };

    /* Product for the server-rendered gallery (used to decide overlay vs Flickity). */
    var GALLERY_GENDER = config.defaultGender ||
      (config.products.Women ? 'Women' : (config.products.Men ? 'Men' : ''));

    function topProduct() {
      return prodForGender(config.products, S.top.gender) ||
             config.products.Women || config.products.Men || null;
    }
    /* Colours available for the current top gender (that product's Color option). */
    function topColors() {
      var p = topProduct();
      return p ? optVals(p, 'Color') : [];
    }
    /* Sizes for the current top gender+colour, available only. */
    function topSizes() {
      var p = topProduct();
      if (!p) return [];
      var all = optVals(p, 'Size');
      if (!S.top.color) return all;
      return all.filter(function(s){ var v = findVariant(p, S.top.color, s); return v && v.available; });
    }
    function initTop() {
      var genders = Object.keys(config.products);
      S.top.gender = (config.defaultGender && config.products[config.defaultGender])
        ? config.defaultGender : (genders[0] || '');
      var cs = topColors();
      S.top.color = cs.length ? cs[0] : '';
      var szs = topSizes();
      S.top.size = szs.length ? szs[0] : '';
    }

    function tier(id) {
      var tid = id !== undefined ? id : S.tierId;
      for (var i = 0; i < config.tiers.length; i++)
        if (config.tiers[i].id === tid) return config.tiers[i];
      return null;
    }
    function selTier()   { return tier(S.tierId); }
    function isSingle(t) { return t && t.quantity === 1; }

    function ensurePairs(qty) {
      while (S.pairs.length < qty) S.pairs.push({gender:'',color:'',size:''});
      S.pairs = S.pairs.slice(0, qty);
    }

    function basePrice() {
      var p = topProduct() || config.products.Women || config.products.Men;
      return p ? p.price : 0;
    }
    function pricePer(t)  { return basePrice() * (1 - t.discountPercent/100); }
    function totalC(t)    { return Math.round(pricePer(t) * t.quantity); }
    function regularC(t)  { return Math.round(basePrice() * t.quantity); }

    function insoleProduct(t) { return t && t.insoleKey ? GP[t.insoleKey] || null : null; }
    function bagProduct(t)    { return t && t.bagKey    ? GP[t.bagKey]    || null : null; }
    function insoleHasVariants(t) {
      var gp = insoleProduct(t);
      return !!(gp && gp.variants && gp.variants.length > 1);
    }
    function firstAvailVariant(gp) {
      if (!gp || !gp.variants || !gp.variants.length) return null;
      for (var i = 0; i < gp.variants.length; i++) {
        if (gp.variants[i].available) return gp.variants[i];
      }
      return gp.variants[0];
    }
    function resolveInsoleVariant(t) {
      var gp = insoleProduct(t);
      if (!gp || !gp.variants || !gp.variants.length) return null;
      var sel = (t && S.giftSel[t.id]) || {};
      if (sel.color || sel.size) {
        var ci = optIdx(gp, 'Color'), si = optIdx(gp, 'Size');
        for (var i = 0; i < gp.variants.length; i++) {
          var v  = gp.variants[i];
          var mc = ci === -1 || !sel.color || v['option'+(ci+1)] === sel.color;
          var ms = si === -1 || !sel.size  || v['option'+(si+1)] === sel.size;
          if (mc && ms && v.available) return v;
        }
      }
      return firstAvailVariant(gp);
    }
    function tierGifts(t) {
      var gp1 = insoleProduct(t);
      var gp2 = bagProduct(t);
      if (gp1 && gp2 && gp1.id === gp2.id) { gp2 = null; }
      return { gp1: gp1, gp2: gp2 };
    }

    /* ── Card (any qty; 1-pair renders too) ───────────────── */
    function cardHtml(t) {
      var fmt  = config.moneyFormat;
      var sel  = t.id === S.tierId;
      var per  = pricePer(t);
      var g    = tierGifts(t);
      var isBest = t.badgeStyle === 'best';
      var badge = t.badge
        ? '<div class="obf-card-badge '+(isBest?'is-best':'is-popular')+'">'+e(t.badge)+'</div>'
        : '';
      var nowStr = money(Math.round(per), fmt);
      var wasStr = t.discountPercent > 0 ? money(Math.round(basePrice()), fmt) : '';
      var saveAmt = regularC(t) - totalC(t);
      var saveStr = saveAmt > 0 ? (config.labels.save || 'Save') + ' ' + money(saveAmt, fmt) : '';
      var discStr = t.discountPercent > 0 ? t.discountPercent + '% off' : '';

      var gifts = [];
      if (g.gp1) gifts.push(g.gp1.title);
      if (g.gp2) gifts.push(g.gp2.title);

      var h = '<div class="obf-card'+(sel?' is-selected':'')+(isBest?' is-best':'')+'" '
            + 'data-tier-id="'+t.id+'" role="button" tabindex="0" aria-pressed="'+(sel?'true':'false')+'">';
      h += badge;
      h += '<div class="obf-card-top">';
      h +=   '<div class="obf-card-check'+(sel?' is-on':'')+'"><span class="obf-card-check-dot"></span></div>';
      h +=   '<span class="obf-card-qty">'+e(t.label || (t.quantity + ' Pairs'))+'</span>';
      h += '</div>';
      h += '<div class="obf-card-price">';
      h +=   '<span class="obf-card-now">'+e(nowStr)+'</span>';
      h +=   '<span class="obf-card-per">'+e(config.labels.perPair || '/pair')+'</span>';
      if (wasStr) h += '<s class="obf-card-was">'+e(wasStr)+'</s>';
      h += '</div>';
      if (saveStr) h += '<div class="obf-card-save">'+e(saveStr)+(discStr ? ' · '+e(discStr) : '')+'</div>';
      if (gifts.length) {
        h += '<div class="obf-card-gifts"><span class="obf-card-gift">🎁 '+e(gifts.join(' + ') + ' free')+'</span></div>';
      }
      h += '</div>';
      return h;
    }

    function bodyHtml(t) {
      var g = tierGifts(t);
      var h = '<div class="obf-body-inner">';
      /* Show a colour/size row for EVERY pair in the pack (all pre-filled from
         the top selection). The shopper tweaks any pair they want different. */
      h += '<div class="obf-pair-rows-label">'
         + e((config.labels.chooseColors || 'Choose your colors'))
         + '</div>';
      h += '<div class="obf-pair-rows">';
      S.pairs.forEach(function(pair, i) { h += pairRowHtml(pair, i, false); });
      h += '</div>';
      if (g.gp1 || g.gp2) h += giftInlineHtml(t, g.gp1, g.gp2);
      h += '</div>';
      return h;
    }

    /* ════════ TOP PICKERS (PDP-parity: gender / colour / size) ════════
       Mirrors snippets/product-option.liquid markup + classes so obf-pdp.css
       and product.css style them identically. Wrapped in `.variations` so the
       theme's base swatch/size-pill rules (which are `.variations`-scoped) apply.
       These are the SINGLE SOURCE OF TRUTH: the tier cards seed pair 0 from
       S.top; changing gender/colour/size here updates the gallery, price, and
       the open tier's first pair. */
    function renderTop() {
      var host = root.querySelector('[data-obf-top]');
      if (!host) return;
      var genders = Object.keys(config.products);
      var multiGender = genders.length > 1;
      var prod = topProduct();
      var colors = topColors();
      var allSizes = prod ? optVals(prod, 'Size') : [];
      var h = '<div class="variations">';

      /* Gender switch — same markup as product-option.liquid, but buttons that
         switch IN-PLACE (no navigation) instead of <a href> to the other PDP. */
      if (multiGender) {
        h += '<div class="obf-gender">';
        genders.forEach(function(g){
          var on = S.top.gender === g;
          h += '<button type="button" class="obf-gender__btn'+(on?' is-active':'')+'" '
             + 'data-obf-gender="'+e(g)+'"'+(on?' aria-current="true"':'')+'>'+e(g)+'</button>';
        });
        h += '</div>';
      }

      /* Colour swatches — fieldset.product-form__input--color + .obf-swatch-scroll,
         labels carry --option-color-image (the variant thumb) exactly like the PDP. */
      h += '<fieldset class="product-form__input product-form__input--color product-form__input--color--regular" data-use-images="true" data-index="option1" data-handle="color">';
      h += '<div class="form__label">'+e(config.labels.selectColor||'Color')+': <span class="form__label__value">'+e(S.top.color||'')+'</span></div>';
      h += '<div class="obf-swatch-scroll">';
      colors.forEach(function(c, idx){
        var img = colorSwatchImg(prod, c);
        var mid = colorMediaIdForProduct(prod, c);
        var checked = S.top.color === c ? ' checked' : '';
        var style = img ? "--option-color: var(--bg-body); --option-color-image: url('"+e(img)+"');" : "--option-color: #ddd;";
        h += '<input type="radio" id="obf-lp-color-'+idx+'" name="obf-lp-color" value="'+e(c)+'" '
           + 'data-obf-top-color data-handle="'+e(handleize(c))+'" data-available="true"'
           + (mid ? ' data-featured-media-id="'+e(mid)+'"' : '') + checked + '>';
        h += '<label for="obf-lp-color-'+idx+'" style="'+style+'">'+e(c)+'</label>';
      });
      h += '</div></fieldset>';

      /* Size buttons — fieldset.product-form__input--block, labels strip W/M for
         display (sizeLabel), disabled/unavailable get .is-disabled like the PDP.
         The size-guide callout (.obf-sizehelp) sits right under the Size label. */
      h += '<fieldset class="product-form__input product-form__input--block" data-index="option2" data-handle="size">';
      h += '<div class="form__label">'+e(config.labels.selectSize||'Size')+': <span class="form__label__value">'+e(sizeLabel(S.top.size||''))+'</span></div>';
      if (config.sizingLinkHtml) {
        h += '<div class="obf-sizehelp" data-obf-sizehelp>'
           + '<span class="obf-sizehelp__txt"><strong>Barefoot shoes fit differently.</strong> Sizes often run short.</span>'
           + config.sizingLinkHtml
           + '</div>';
      }
      allSizes.forEach(function(s, idx){
        var v = prod && S.top.color ? findVariant(prod, S.top.color, s) : null;
        var avail = !S.top.color || (v && v.available);
        var checked = S.top.size === s ? ' checked' : '';
        h += '<input type="radio" id="obf-lp-size-'+idx+'" name="obf-lp-size" value="'+e(s)+'" '
           + 'data-obf-top-size data-handle="'+e(handleize(s))+'" data-available="'+(avail?'true':'false')+'"'
           + (avail ? '' : ' class="is-disabled" disabled') + checked + '>';
        h += '<label for="obf-lp-size-'+idx+'"><span>'+e(sizeLabel(s))+'</span></label>';
      });
      h += '</fieldset>';

      h += '</div>';
      host.innerHTML = h;
      bindTopEvents();
    }

    function bindTopEvents() {
      var host = root.querySelector('[data-obf-top]');
      if (!host) return;
      host.querySelectorAll('.obf-gender__btn[data-obf-gender]').forEach(function(btn){
        btn.addEventListener('click', function(){ setTopGender(btn.getAttribute('data-obf-gender')); });
      });
      host.querySelectorAll('input[data-obf-top-color]').forEach(function(r){
        r.addEventListener('change', function(){ if (r.checked) setTopColor(r.value); });
      });
      host.querySelectorAll('input[data-obf-top-size]').forEach(function(r){
        r.addEventListener('change', function(){ if (r.checked) setTopSize(r.value); });
      });
    }

    /* Seed the open tier's pair 0 from the top selection (top drives the single
       pair AND the bundle reads from the top pickers, exactly like the PDP). */
    function seedPair0FromTop() {
      if (!S.pairs.length) return;
      S.pairs[0].gender = S.top.gender;
      S.pairs[0].color  = S.top.color;
      S.pairs[0].size   = S.top.size;
    }

    function setTopGender(g) {
      if (S.top.gender === g) return;
      S.top.gender = g;
      /* keep the colour if the new gender has it, else first available */
      var cs = topColors();
      if (cs.indexOf(S.top.color) === -1) S.top.color = cs.length ? cs[0] : '';
      var szs = topSizes();
      if (szs.indexOf(S.top.size) === -1) S.top.size = szs.length ? szs[0] : '';
      seedPair0FromTop();
      renderTop(); renderTiers(); renderCta(); updateTopPrice(); syncGalleryTop();
    }
    function setTopColor(c) {
      S.top.color = c;
      var szs = topSizes();
      if (szs.indexOf(S.top.size) === -1) S.top.size = szs.length ? szs[0] : '';
      seedPair0FromTop();
      renderTop(); renderTiers(); renderCta(); syncGalleryTop();
    }
    function setTopSize(s) {
      S.top.size = s;
      seedPair0FromTop();
      renderTop(); renderTiers(); renderCta();
    }

    /* Gallery swap from the TOP colour/gender. If the chosen gender matches the
       server-rendered gallery product, use the Flickity slide swap (mediaId).
       Otherwise pass a heroImage so the section shows the other product's image
       via an overlay <img>. */
    function syncGalleryTop() {
      var prod = topProduct();
      var mediaId = colorMediaIdForProduct(prod, S.top.color);
      var isGalleryGender = (S.top.gender === GALLERY_GENDER) || !GALLERY_GENDER;
      var hero = '';
      if (!isGalleryGender) {
        /* large image for the overlay: variant heroImg for the colour, else product hero */
        var ci = prod ? optIdx(prod, 'Color') : -1;
        if (prod && ci !== -1 && S.top.color) {
          for (var i = 0; i < prod.variants.length; i++) {
            if (prod.variants[i]['option'+(ci+1)] === S.top.color && prod.variants[i].heroImg) { hero = prod.variants[i].heroImg; break; }
          }
        }
        hero = hero || (prod && prod.heroImage) || (prod && prod.image) || '';
      }
      document.dispatchEvent(new CustomEvent('obf-lp:color', {
        detail: { color: S.top.color, gender: S.top.gender, mediaId: mediaId, heroImage: hero, useOverlay: !isGalleryGender }
      }));
    }

    /* Update the reused obf-price block on gender change (Women/Men may differ). */
    function updateTopPrice() {
      var prod = topProduct();
      if (!prod) return;
      var info = root.closest('.obf-lpbb__info');
      var host = info ? info.querySelector('.obf-price') : null;
      if (!host) return;
      var fmt = config.moneyFormat;
      var now = host.querySelector('.obf-price__now');
      var was = host.querySelector('.obf-price__was');
      if (now) now.textContent = money(prod.price, fmt);
      if (was && prod.compareAtPrice && prod.compareAtPrice > prod.price) {
        was.textContent = money(prod.compareAtPrice, fmt);
      }
    }

    /* ── Render: label + ALL cards (incl. 1-pair) ─────────── */
    function renderTiers() {
      var container = root.querySelector('[data-obf-tiers]');
      /* PDP parity: NO 1-pair card. The single pair is the top pickers + CTA
         (passthrough). Only 2+ pair packs render as upsell cards. */
      var cardTiers = config.tiers.filter(function(t) { return t.quantity >= 2; });
      var html = '';
      if (cardTiers.length) {
        html += '<div class="obf-upsell-label"><span>'+e(config.labels.upsell || 'Buy more, save more')+'</span></div>';
      }
      html += '<div class="obf-cards" data-cols="'+cardTiers.length+'">';
      html += cardTiers.map(cardHtml).join('');
      html += '</div>';
      var t = selTier();
      html += '<div class="obf-expand">';
      if (t) html += bodyHtml(t);
      html += '</div>';
      container.innerHTML = html;

      container.querySelectorAll('.obf-card').forEach(function(card) {
        card.addEventListener('click', function() { toggleTier(card.dataset.tierId); });
        card.addEventListener('keydown', function(ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); toggleTier(card.dataset.tierId); }
        });
      });
      bindSelectEvents();
      bindColorDropdowns();
    }

    function pairRowHtml(pair, i, single) {
      var prod        = pair.gender ? prodForGender(config.products, pair.gender) : null;
      var sizes       = prod ? optVals(prod, 'Size') : [];
      var colors      = (function() {
        var w = config.products.Women ? optVals(config.products.Women, 'Color') : [];
        var m = config.products.Men   ? optVals(config.products.Men,   'Color') : [];
        var r = w.slice();
        m.forEach(function(c) { if (r.indexOf(c) === -1) r.push(c); });
        return r;
      })();
      var genders      = Object.keys(config.products);
      var multiGender  = genders.length > 1;
      var sizeDisabled = !pair.gender || !pair.color;

      var html = '<div class="obf-pair-row" data-pi="'+i+'">';
      if (!single) {
        html += '<div class="obf-pair-label">'+(config.labels.pair||'Pair')+' '+(i+1)+'</div>';
      }
      html += '<div class="obf-pair-selects'+(multiGender?' has-gender':'')+'">';
      if (multiGender) {
        html += '<div class="obf-sel-group">';
        html += '<label class="obf-sel-label">'+e(config.labels.selectGender||'Gender')+'</label>';
        html += '<select class="obf-select obf-select--gender" data-pair="'+i+'" data-field="gender">';
        if (!pair.gender) html += '<option value="">—</option>';
        genders.forEach(function(g) {
          html += '<option value="'+e(g)+'"'+(pair.gender===g?' selected':'')+'>'+e(g)+'</option>';
        });
        html += '</select>';
        html += '</div>';
      }
      html += '<div class="obf-sel-group">';
      html += '<label class="obf-sel-label">'+e(config.labels.selectColor||'Color')+'</label>';
      html += colorDropdownHtml('data-cc-kind="pair" data-cc-pair="'+i+'"', pair.color, colors, function(c){
        return thumbFor(config.products, pair.gender, c, '');
      });
      html += '</div>';
      html += '<div class="obf-sel-group">';
      html += '<label class="obf-sel-label">'+e(config.labels.selectSize||'Size')+'</label>';
      html += '<select class="obf-select obf-select--size" data-pair="'+i+'" data-field="size"'+(sizeDisabled?' disabled':'')+' >';
      html += '<option value="">—</option>';
      var availSizes = sizes.filter(function(s) {
        if (!pair.color || !prod) return true;
        var v = findVariant(prod, pair.color, s);
        return v && v.available;
      });
      availSizes.forEach(function(s) {
        html += '<option value="'+e(s)+'"'+(pair.size===s?' selected':'')+'>'+e(sizeLabel(s))+'</option>';
      });
      html += '</select>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
      return html;
    }

    function giftInlineHtml(t, gp1, gp2) {
      var gSel = S.giftSel[t.id] || {};
      var gp1Img = gp1 ? gp1.image : null;
      if (gp1 && gSel.color) {
        var ci1 = optIdx(gp1, 'Color');
        for (var k = 0; k < gp1.variants.length; k++) {
          var vk = gp1.variants[k];
          if (ci1 !== -1 && vk['option'+(ci1+1)] === gSel.color && vk.image) { gp1Img = vk.image; break; }
        }
      }
      var giftCount = (gp1 ? 1 : 0) + (gp2 ? 1 : 0);
      var html = '<div class="obf-gift-inline">';
      html += '<div class="obf-gift-inline-header">🎁 <strong>Your free gift'+(giftCount > 1 ? 's' : '')+'</strong></div>';
      if (gp1) {
        var gColors = optVals(gp1, 'Color');
        var gSizes  = optVals(gp1, 'Size');
        var hasGColor = gColors.length > 0;
        var hasGSize  = gSizes.length  > 0;
        var availGSizes = gSizes.filter(function(sz) {
          if (!hasGColor || !gSel.color) return true;
          var vv = findVariant(gp1, gSel.color, sz);
          return vv && vv.available;
        });
        html += '<div class="obf-gift-item">';
        html +=   '<div class="obf-gift-item-main">';
        if (gp1Img) {
          html += '<img class="obf-gift-item-img" src="'+e(gp1Img)+'" alt="'+e(gp1.title)+'" width="40" height="40" loading="lazy" decoding="async" data-gift-img="'+t.id+'">';
        }
        html +=     '<div class="obf-gift-item-info"><span class="obf-gift-item-name">'+e(gp1.title)+'</span></div>';
        html +=   '</div>';
        if (hasGColor || hasGSize) {
          html += '<div class="obf-gift-pickers">';
          if (hasGColor) {
            html += '<div class="obf-sel-group">';
            html += '<label class="obf-sel-label">'+e(config.labels.selectColor || 'Color')+'</label>';
            html += colorDropdownHtml('data-cc-kind="gift" data-cc-tid="'+t.id+'"', gSel.color, gColors, function(c){
              return productColorThumb(gp1, c);
            });
            html += '</div>';
          }
          if (hasGSize) {
            var gSizeDisabled = hasGColor && !gSel.color;
            html += '<div class="obf-sel-group">';
            html += '<label class="obf-sel-label">'+e(config.labels.selectSize || 'Size')+'</label>';
            html += '<select class="obf-select obf-select--gsize" data-tid="'+t.id+'" data-gfield="size"'+(gSizeDisabled?' disabled':'')+'>';
            html += '<option value="">—</option>';
            availGSizes.forEach(function(sz) {
              html += '<option value="'+e(sz)+'"'+(gSel.size===sz?' selected':'')+'>'+e(sz)+'</option>';
            });
            html += '</select></div>';
          }
          html += '</div>';
        }
        html += '</div>';
      }
      if (gp2) {
        html += '<div class="obf-gift-item obf-gift-item--divider">';
        html +=   '<div class="obf-gift-item-main">';
        if (gp2.image) {
          html += '<img class="obf-gift-item-img" src="'+e(gp2.image)+'" alt="'+e(gp2.title)+'" width="40" height="40" loading="lazy" decoding="async">';
        }
        html +=     '<div class="obf-gift-item-info"><span class="obf-gift-item-name">'+e(gp2.title)+'</span></div>';
        html +=   '</div>';
        html += '</div>';
      }
      html += '</div>';
      return html;
    }

    /* ── LP gallery sync: broadcast the pair-1 colour ─────── */
    function syncGallery(pair) {
      if (!pair) return;
      var mediaId = colorMediaId(config.products, pair.gender, pair.color);
      document.dispatchEvent(new CustomEvent('obf-lp:color', {
        detail: { color: pair.color, gender: pair.gender, mediaId: mediaId }
      }));
    }

    function bindSelectEvents() {
      var container = root.querySelector('[data-obf-tiers]');
      container.querySelectorAll('.obf-select[data-pair]').forEach(function(sel) {
        sel.addEventListener('change', function(ev) {
          var i     = +ev.target.dataset.pair;
          var field = ev.target.dataset.field;
          S.pairs[i][field] = ev.target.value;
          if (field === 'gender') { S.pairs[i].color = ''; S.pairs[i].size = ''; }
          if (field === 'color') {
            var curSize = S.pairs[i].size;
            if (curSize) {
              var pChk = prodForGender(config.products, S.pairs[i].gender);
              var vChk = pChk ? findVariant(pChk, S.pairs[i].color, curSize) : null;
              if (!vChk || !vChk.available) S.pairs[i].size = '';
            }
          }
          if (field === 'gender' || field === 'color') { renderTiers(); } else { renderCta(); }
          if (i === 0) syncGallery(S.pairs[0]);
        });
      });
      container.querySelectorAll('.obf-select[data-gfield]').forEach(function(sel) {
        sel.addEventListener('change', function(ev) {
          var tid   = ev.target.dataset.tid;
          var field = ev.target.dataset.gfield;
          if (!S.giftSel[tid]) S.giftSel[tid] = { color:'', size:'' };
          S.giftSel[tid][field] = ev.target.value;
          if (field === 'color') S.giftSel[tid].size = '';
          renderTiers(); renderCta();
        });
      });
    }

    function setPairColor(i, value) {
      S.pairs[i].color = value;
      var curSize = S.pairs[i].size;
      if (curSize) {
        var pChk = prodForGender(config.products, S.pairs[i].gender);
        var vChk = pChk ? findVariant(pChk, value, curSize) : null;
        if (!vChk || !vChk.available) S.pairs[i].size = '';
      }
      renderTiers();
      if (i === 0) syncGallery(S.pairs[0]);
    }
    function setGiftColor(tid, value) {
      if (!S.giftSel[tid]) S.giftSel[tid] = { color:'', size:'' };
      S.giftSel[tid].color = value;
      S.giftSel[tid].size  = '';
      renderTiers(); renderCta();
    }

    function closeColorMenus(except) {
      root.querySelectorAll('.obf-color-dd.is-open').forEach(function(o) {
        if (o === except) return;
        o.classList.remove('is-open');
        var m = o.querySelector('.obf-color-dd-menu'); if (m) m.hidden = true;
        var b = o.querySelector('.obf-color-dd-btn');  if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    function bindColorDropdowns() {
      var container = root.querySelector('[data-obf-tiers]');
      container.querySelectorAll('.obf-color-dd').forEach(function(dd) {
        var btn  = dd.querySelector('.obf-color-dd-btn');
        var menu = dd.querySelector('.obf-color-dd-menu');
        if (!btn || !menu) return;
        btn.addEventListener('click', function(ev) {
          ev.stopPropagation();
          var willOpen = !dd.classList.contains('is-open');
          closeColorMenus(dd);
          dd.classList.toggle('is-open', willOpen);
          menu.hidden = !willOpen;
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        var kind = dd.getAttribute('data-cc-kind');
        menu.querySelectorAll('.obf-color-dd-opt').forEach(function(opt) {
          opt.addEventListener('click', function(ev) {
            ev.stopPropagation();
            if (kind === 'gift') setGiftColor(dd.getAttribute('data-cc-tid'), opt.dataset.value);
            else                 setPairColor(+dd.getAttribute('data-cc-pair'), opt.dataset.value);
          });
        });
      });
      if (!root.__obfColorDocBound) {
        root.__obfColorDocBound = true;
        document.addEventListener('click', function() { closeColorMenus(null); });
        document.addEventListener('keydown', function(ev) { if (ev.key === 'Escape') closeColorMenus(null); });
      }
    }

    function renderCta() {
      var t       = selTier();
      var cta     = root.querySelector('[data-obf-cta]');
      var priceEl = root.querySelector('[data-obf-cta-price]');
      var labelEl = root.querySelector('[data-obf-cta-label]');
      var fmt     = config.moneyFormat;
      if (!cta) return;
      function setLabel(txt) { if (labelEl) labelEl.textContent = txt; }
      function setPrice(html) { if (priceEl) priceEl.innerHTML = html; }

      cta.style.display = '';

      if (!t) {
        /* SINGLE PAIR (passthrough) — the top pickers ARE the selection. */
        cta.dataset.mode = 'passthrough';
        setLabel(config.labels.addSingle || config.labels.addToCart || 'Add to Cart');
        var prodS = topProduct();
        var reg1 = prodS && prodS.compareAtPrice && prodS.compareAtPrice > prodS.price ? prodS.compareAtPrice : 0;
        setPrice(money(basePrice(), fmt) + (reg1 ? ' <s>'+money(reg1, fmt)+'</s>' : ''));
        var okS = !!(S.top.color && S.top.size && (Object.keys(config.products).length === 1 || S.top.gender));
        if (okS) { var vS = findVariant(topProduct(), S.top.color, S.top.size); okS = !!(vS && vS.available); }
        cta.disabled = !okS;
        return;
      }

      cta.dataset.mode = 'bundle';
      setLabel(config.labels.addToCart || 'Add to Cart');
      var tot = totalC(t), reg = regularC(t);
      setPrice(money(tot,fmt) + (reg > tot ? ' <s>'+money(reg,fmt)+'</s>' : ''));

      var pairsOk = S.pairs.length === t.quantity && S.pairs.every(function(p) {
        if (!p.gender || !p.color || !p.size) return false;
        var prod = prodForGender(config.products, p.gender);
        var v    = findVariant(prod, p.color, p.size);
        return !!(v && v.available);
      });
      var giftOk = !insoleHasVariants(t) || !!resolveInsoleVariant(t);
      cta.disabled = !(pairsOk && giftOk);
    }

    function toggleTier(tierId) {
      if (S.tierId === tierId) {
        S.tierId = null; S.pairs = [];
      } else {
        S.tierId = tierId;
        var t = selTier();
        if (t) {
          ensurePairs(t.quantity);
          /* PDP parity: clicking a pack PRE-FILLS every pair from the top
             selection (gender/colour/size), so the shopper only tweaks the ones
             they want different. */
          for (var pi = 0; pi < S.pairs.length; pi++) {
            S.pairs[pi].gender = S.top.gender;
            S.pairs[pi].color  = S.top.color;
            S.pairs[pi].size   = S.top.size;
          }
          if (!S.giftSel[tierId]) {
            var gp1auto = insoleProduct(t);
            if (gp1auto && gp1auto.variants && gp1auto.variants.length) {
              var ci1a = optIdx(gp1auto, 'Color');
              var si1a = optIdx(gp1auto, 'Size');
              var fv   = firstAvailVariant(gp1auto);
              S.giftSel[tierId] = {
                color: ci1a !== -1 ? fv['option'+(ci1a+1)] : '',
                size:  si1a !== -1 ? fv['option'+(si1a+1)] : ''
              };
            }
          }
        }
      }
      renderTiers(); renderCta();
    }

    function fieldEl(i, f) {
      /* Single-pair (no pack open): pair 0 lives in the TOP pickers. */
      if (i === 0 && !selTier()) {
        var top = root.querySelector('[data-obf-top]');
        if (!top) return null;
        if (f === 'gender') return top.querySelector('.obf-gender');
        if (f === 'color')  return top.querySelector('.product-form__input--color');
        if (f === 'size')   return top.querySelector('.product-form__input--block');
        return null;
      }
      if (f === 'color') return root.querySelector('.obf-color-dd[data-cc-kind="pair"][data-cc-pair="'+i+'"]');
      return root.querySelector('.obf-select[data-pair="'+i+'"][data-field="'+f+'"]');
    }
    function clearAllInvalid() {
      root.querySelectorAll('.obf-select.is-invalid, .obf-color-dd.is-invalid, .product-form__input.is-invalid, .obf-gender.is-invalid')
          .forEach(function(el){ el.classList.remove('is-invalid'); });
    }
    function firstInvalidEl() {
      return root.querySelector('.product-form__input.is-invalid, .obf-gender.is-invalid, .obf-select.is-invalid, .obf-color-dd.is-invalid');
    }

    function validate() {
      var t = selTier();
      clearAllInvalid();
      /* SINGLE PAIR (no pack selected): validate the top pickers, then add one. */
      if (!t) {
        var needG = Object.keys(config.products).length > 1;
        var okS = true;
        (needG ? ['gender','color','size'] : ['color','size']).forEach(function(f){
          if (!S.top[f]) { okS = false; var el = fieldEl(0, f); if (el) el.classList.add('is-invalid'); }
        });
        if (okS) {
          var vS = findVariant(topProduct(), S.top.color, S.top.size);
          if (!vS || !vS.available) { okS = false; var ec = fieldEl(0,'color'); if (ec) ec.classList.add('is-invalid'); var es = fieldEl(0,'size'); if (es) es.classList.add('is-invalid'); }
        }
        if (!okS) { var fi = firstInvalidEl(); if (fi) fi.scrollIntoView({behavior:'smooth',block:'center'}); return; }
        doAddSingle();
        return;
      }
      var genders = Object.keys(config.products);
      var needGender = genders.length > 1;
      var ok = true;
      S.pairs.forEach(function(p,i){
        (needGender ? ['gender','color','size'] : ['color','size']).forEach(function(f){
          if (!p[f]) {
            ok = false;
            var el = fieldEl(i, f);
            if (el) el.classList.add('is-invalid');
          }
        });
        if (p.gender && p.color && p.size) {
          var prod = prodForGender(config.products, p.gender);
          var v    = findVariant(prod, p.color, p.size);
          if (!v || !v.available) {
            ok = false;
            ['color','size'].forEach(function(f){ var el = fieldEl(i, f); if (el) el.classList.add('is-invalid'); });
          }
        }
      });
      if (insoleHasVariants(t) && !resolveInsoleVariant(t)) {
        ok = false;
        root.querySelectorAll('.obf-select[data-gfield]').forEach(function(s){ s.classList.add('is-invalid'); });
      }
      if (!ok) {
        var first = firstInvalidEl();
        if (first) first.scrollIntoView({ behavior:'smooth', block:'center' });
        return;
      }
      doAdd(t);
    }

    function doAdd(t) {
      var cta = root.querySelector('[data-obf-cta]');
      cta.classList.add('is-loading'); cta.disabled = true;
      var bid     = 'OBF-'+t.quantity+'PK-'+Date.now();
      var per     = pricePer(t);
      var savings = ((basePrice()-per)/100).toFixed(2);
      var iv  = resolveInsoleVariant(t);
      var gp2 = bagProduct(t);
      var giftInsoleId = iv ? String(iv.id) : '';
      var giftBagId    = (gp2 && gp2.variants && gp2.variants[0]) ? String(gp2.variants[0].id) : '';

      var items = S.pairs.map(function(p){
        var prod = prodForGender(config.products, p.gender);
        var v    = findVariant(prod, p.color, p.size);
        return { id:v.id, quantity:1, properties:{
          '_obf_bundle_id':bid, '_obf_bundle_size':t.quantity,
          '_obf_bundle_discount':t.discountPercent+'%',
          '_obf_savings_per_pair':savings,
          '_obf_gift_insole_id': giftInsoleId,
          '_obf_gift_bag_id':    giftBagId
        }};
      });
      if (iv) items.push({ id:iv.id, quantity:1, properties:{ _obf_bundle_id:bid, _obf_gift:'insoles' } });
      if (gp2 && gp2.variants && gp2.variants[0])
        items.push({ id:gp2.variants[0].id, quantity:1, properties:{ _obf_bundle_id:bid, _obf_gift:'bag' } });

      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(){
          cta.classList.remove('is-loading'); cta.disabled = false;
          ['cart:refresh','cart:updated','cart-drawer:refresh'].forEach(function(n){
            document.dispatchEvent(new CustomEvent(n,{bubbles:true}));
            window.dispatchEvent(new CustomEvent(n,{bubbles:true}));
          });
          openDrawer();
        })
        .catch(function(err){
          console.error('[OBF-LP]',err);
          cta.classList.remove('is-loading'); cta.disabled = false;
          alert("Sorry — couldn't add to cart. Please try again.");
        });
    }

    /* Single pair (no pack) — add one variant resolved from the top pickers. */
    function doAddSingle() {
      var prod = topProduct();
      var v = findVariant(prod, S.top.color, S.top.size);
      if (!v) return;
      var cta = root.querySelector('[data-obf-cta]');
      cta.classList.add('is-loading'); cta.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(){
          cta.classList.remove('is-loading'); cta.disabled = false;
          ['cart:refresh','cart:updated','cart-drawer:refresh'].forEach(function(n){
            document.dispatchEvent(new CustomEvent(n,{bubbles:true}));
            window.dispatchEvent(new CustomEvent(n,{bubbles:true}));
          });
          openDrawer();
        })
        .catch(function(err){
          console.error('[OBF-LP]',err);
          cta.classList.remove('is-loading'); cta.disabled = false;
          alert("Sorry — couldn't add to cart. Please try again.");
        });
    }

    function init() {
      if (!config.tiers || !config.tiers.length) { root.style.display = 'none'; return; }
      if (!config.products.Women && !config.products.Men) {
        root.innerHTML = '<p style="padding:16px;color:#B23A2B">OBF LP Bundle: no products configured.</p>';
        return;
      }
      root.querySelector('[data-obf-cta]').addEventListener('click', validate);

      /* Ensure a top-pickers mount exists ABOVE the tier cards. The snippet may
         already provide [data-obf-top]; if not, create it before [data-obf-tiers]. */
      var topHost = root.querySelector('[data-obf-top]');
      if (!topHost) {
        topHost = document.createElement('div');
        topHost.setAttribute('data-obf-top', '');
        var tiersHost = root.querySelector('[data-obf-tiers]');
        tiersHost.parentNode.insertBefore(topHost, tiersHost);
      }

      /* Initialise the top single-source-of-truth selection (gender/colour/size)
         and render the top pickers (gender switch, colour swatches, size pills). */
      initTop();
      renderTop();

      /* PDP parity: on load NO pack is pre-selected — the single pair (top
         pickers + CTA) is the default state. The owner MAY pre-open a 2+ pair
         pack via obf_lp_default_tier; tier-1 (or an invalid/single tier) means
         "no pack, single pair". */
      var def = config.defaultTierId;
      var defTier = def ? tier(def) : null;
      renderTiers();
      if (defTier && defTier.quantity >= 2) { toggleTier(def); }
      else { renderCta(); }
      /* Sync the gallery to the initial top colour on load. */
      syncGalleryTop();
    }

    init();
  }

  function boot() {
    document.querySelectorAll('[data-obf-lp-bundle]').forEach(function(el){
      if (!el.__obfLpInit) { el.__obfLpInit = true; OBFLpBundle(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
